module.exports = __webpack_public_path__ + "static/img/logo-konstanz.57b629d3.png";